export var FinanceDisclaimersTags;
(function (FinanceDisclaimersTags) {
    FinanceDisclaimersTags["GFV"] = "<sup>1</sup>";
    FinanceDisclaimersTags["REPAYMENT"] = "<sup>2</sup>";
    FinanceDisclaimersTags["COMPARISON_RATE"] = "<sup>4</sup>";
})(FinanceDisclaimersTags || (FinanceDisclaimersTags = {}));
//# sourceMappingURL=FinanceDisclaimersTags.js.map